import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    getProducts(offset = 0, limit = 0) {
        let page = '';
        if (parseInt(limit, 10) > 0) {
            page = `/offset/${offset}/limit/${limit}`;
        }
        return API.get(`products${page}`)
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
    addProduct(formdata) {
        return API.post('addproduct', httpBuildQuery(formdata))
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
    editProduct(formdata) {
        return API.post('editProduct', httpBuildQuery(formdata))
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
    getProductInfo(id) {
        return API.get(`getProductInfo/id/${id}`)
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
    updateProductStatus(id, status) {
        return API.get(`updateProductStatus/id/${id}/status/${status}`).then((res) => {
            const result = res.data;
            return result;
        });
    },
};
